// import { Link } from "react-router-dom";
import { Link } from "react-scroll";

const Footer = () => {
  return (
    <>
      <footer className="custom-footer">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="footer-links">
                <div className="links">
                  <ul className="list-inline">
                    <li>
                      <Link id="li-pointer" to="about">
                        Coin
                      </Link>
                    </li>
                    <li>
                      <Link id="li-pointer" to="tokenomics">
                        Front Pocket
                      </Link>
                    </li>
                    <li>
                      <Link id="li-pointer" to="roadmap">
                        Back Pocket
                      </Link>
                    </li>
                    {/* <li>
                      <Link id="li-pointer" to="">About us</Link>
                    </li>
                    <li>
                      <Link id="li-pointer" to="">Tokenomics</Link>
                    </li> */}
                  </ul>
                </div>
                <div className="social">
                  <h4>Join our community</h4>
                  <ul className="list-inline">
                    <li>
                      {/* <Link to=""> */}
                        <a
                         href="https://bsky.app/profile/pocket-ventures.bsky.social" target="_blank" rel="noopener noreferrer"
                        >
                          <img
                            id="li-pointer"
                            src="/images/Butterfly.png"
                            alt=""
                          />
                        </a>
                      {/* </Link> */}
                    </li>
                    {/* <li>
                      <Link to="">
                        <img src="/images/twitter.png" alt="" />
                      </Link>
                    </li> */}
                  </ul>
                </div>
              </div>
              <div className="copyright">
                <div>
                  <h4>POCKET Token © 2025 . All rights reserved.</h4>
                </div>
                <div className="otherlink">
                  <ul className="list-inline">
                    <li>
                      <Link id="li-pointer">Terms & Conditions</Link>
                    </li>
                    <li>
                      <Link id="li-pointer" to="">
                        Privacy Policy
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};
export default Footer;
